import Utils from "../utils/Utils";

const getAuth = ({ jwt, Authorization } = {}) => jwt || Authorization || "";

const deliveryHealthController = {
  getDeliveryHealthOverview: ({
    jwt,
    Authorization,
    page = 1,
    search,
    size = 10,
  } = {}) => {
    const params = new URLSearchParams();

    params.append("page", page);
    params.append("size", size);
    if (search) params.append("search", search);

    return Utils.controller(
      "api/delivery-health/v1/getDeliveryHealthOverview",
      "",
      "GET",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },
};

export default deliveryHealthController;
